import React from 'react';
import { SearchEntity } from 'v2/models';
import { SearchArtificialProposalResponseItem } from '../../../SearcherArtificialProposalResponseItem';
import SearchResponseItem, {
  SearchResponseItemProps,
} from '../../../SearchResponseItem';
import { ResponsesListItemType } from '../../enums';
import { ResponsesListItem } from '../../types';

export type ResponsesListItemRendererProps = {
  responsesListItem: ResponsesListItem;
  onAccepted: (searchResponseItem: SearchResponseItemProps) => void;
  request: SearchEntity;
};

export function ResponsesListItemRenderer({
  responsesListItem,
  onAccepted,
  request,
}: ResponsesListItemRendererProps) {
  switch (responsesListItem.type) {
    case ResponsesListItemType.RequestResponse: {
      return (
        <SearchResponseItem
          className="mb-4"
          onAccepted={() => onAccepted(responsesListItem.data)}
          request={request}
          {...responsesListItem.data}
        />
      );
    }

    case ResponsesListItemType.ArtificialProposalResponse: {
      return (
        <SearchArtificialProposalResponseItem
          artificialProposalResponse={responsesListItem.data}
        />
      );
    }
  }
}
